module.exports = __webpack_public_path__ + "img/1cons.0184dd9e.png";